cockpitApp.directive('offlineHintBar', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/offline-hint'
  };
});
